import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-t2-footer-main',
  templateUrl: './t2-footer-main.component.html',
  styleUrls: ['./t2-footer-main.component.scss']
})
export class T2FooterMainComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/trip2-theme/components/t2-footer-main/t2-footer-main.component.ts